<template>
  <el-container>

    <el-header style="padding: 0; min-height: 30px;">
      <el-page-header @back="goBack()" :content="title">
      </el-page-header>
    </el-header>
    <el-main>
      <el-form ref="messageForm" :model="form" :rules="rules" label-width="80px" class="demo-ruleForm t_center"
               align="left">
        <el-form-item label="所属机构" prop="orgCode" class="cls-col">
          <el-select v-model="form.orgCode" placeholder="所属机构" size="small" :disabled="orgEdit" @change="changeOrg">
            <el-option
                v-for="item in organizationData"
                :key="item.orgCode"
                :label="item.organizationName"
                :value="item.orgCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息类别" prop="categoryId" class="cls-col">
          <el-select v-model="form.categoryId" placeholder="消息类别" size="small">
            <el-option
                v-for="item in categoryData"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="" class="cls-col">
          <el-input v-model="form.title" placeholder="标题" style="width: 70%" size="small"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <ckeditor v-model="form.content"></ckeditor>
        </el-form-item>
        <el-form-item label="发送范围" prop="scope" class="cls-col">
          <el-radio-group v-model="form.scope" @change="changeScope">
            <el-radio :label="1">所有注册用户</el-radio>
            <el-radio :label="2">按课程分类发送</el-radio>
            <el-radio :label="3" @click.native.prevent="showdnd">按课程内容发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="课程分类:" :inline="true" prop="ccId" v-show="showform">
          <el-cascader
              expand-trigger="hover"
              :options="courseOptions"
              style="width: 40%"
              :props="{ value: 'ccId', label: 'ccName',children: 'children'}"
              v-model="form.ccId"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item :inline="true" v-if="showSelected">
          <div style="line-height: 19px; width: 250px; float: left" v-for="element in courseList3" :key="element.commodityId" class="list-complete-item">
            <div :title="element.name" class="list-complete-item-handle">
              {{ element.courseName }}
            </div>
            <div style="position:absolute;right:0px;">
              <span style="float: right ;margin-top: -20px;margin-right:5px;" @click="deleteEle1(element)">
                <i style="color:#ff4949" class="el-icon-delete" />
              </span>
            </div>
          </div>
        </el-form-item>
        <el-form-item align="center">
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        
        </el-form-item>
      </el-form>
      <el-dialog
          title="选择课程"
          :visible.sync="choseCommend"
          width="40%"
          :close-on-click-modal=false
          :before-close="handleDialogClose"
      >
        <el-form ref="c_form" :model="form" :rules="rules" label-width="80px" >
          <el-form-item label="课程分类:" :inline="true" >
            <el-cascader
                expand-trigger="hover"
                :options="courseOptions"
                style="width: 40%"
                size="small"
                @change="getCourse"
                :props="{ value: 'ccId', label: 'ccName',children: 'children'}"
                v-model="form.ccId"
            >
            </el-cascader>
          </el-form-item>
        </el-form>
        <div class="editor-container" style="min-height: 500px; max-height: 550px;">
          <course-list :courseList2="courseList2" :courseList1="courseList1"  />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="selectCourse">确 定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js'
  import ckeditor from "@/components/ckeditor/ckeditor.vue";
  import CourseList from '@/components/CourseList'
  const toolbarOptions = [
    ['link','image']
  ];

  export default {
    components: { CourseList,ckeditor },
    data() {
      return {
        courseList1: [],
        courseList2: [],
        courseList3: [],
        title: '添加消息',
        choseCommend: false,
        orgEdit: false,
        showform: false,
        showThird: false,
        showSelected: false,
        CcidFirst: [],
        CcidSecond: [],
        CcidThird: [],
        categoryData: [], //消息分类下拉
        organizationData: [], //机构下拉
        courseOptions: [],
        selectedCourse: '',
        form: {
          categoryId: '',
          content: '',
          scope: 1,
          ccId: '',
          commodityId: '',
          messageId: '',
          orgCode: '',
          title: ''
        },
        rules: {
          categoryId: [{required: true, message: '请选择消息类别', trigger: 'change'}],
          content: [
            {required: true, message: '请输入内容', trigger: 'blur'},
            {max: 1500, message: '长度不得超过 1000 个字符', trigger: 'blur'}
          ],
          orgCode: [
            {required: true, message: '请选择所属机构', trigger: 'change'}
          ],
          scope: [
            {required: true, message: '请选择发送范围', trigger: 'change'}
          ]
        },
        uploadURL: '',
        
        quillUpdateImg: false,
        headers: {
          Authentication: localStorage.getItem('token')  //从cookie里获取token，并赋值  Authorization ，而不是token
        },
        editorOption: {
          placeholder: '',
          theme: 'snow',  // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function(value) {
                  if (value) {
                    document.querySelector('.avatar-uploader input').click();
                  } else {
                    this.quill.format('image', false);
                  }
                }
              }
            }
          }
        }
        //endregion

      };
    },
    methods: {
      
      goBack() {
        this.$router.go(-1);
      },
      //region 上传相关
      onEditorChange({editor, html, text}) {

      },
      isNotInList2(v) {
        return this.courseList2.every(k => v.courseId !== k.courseId)
      },
      deleteEle1(ele){
        for (const item of this.courseList1) {
          if (item.courseId === ele.courseId) {
            const index = this.courseList1.indexOf(item)
            this.courseList1.splice(index, 1);
            this.courseList3.splice(index, 1);
            break
          }
        }
        if (this.isNotInList2(ele)) {
          this.courseList2.unshift(ele)
          
        }
      },
      selectCourse() {
        this.choseCommend = false;
        this.showSelected = true;
        this.courseList3 = JSON.parse(JSON.stringify(this.courseList1))
      },
      getCourse() {
        this.courseList2 = [];
        if(this.form.ccId instanceof Array) {
          if(this.form.ccId.length > 0) {
            this.form.ccId = this.form.ccId[this.form.ccId.length-1];
          }
        }
        let params = {
          ccId: this.form.ccId,
          orgCode: this.form.orgCode,
          commodityStatus: 1,
          isView: 1,
          page:1,
          size: 9999
        };
        https.fetchPost('/commodityInfo/selectListAll', params, 'json').then((data) => {
          console.log(data);
          let code = data.data.code;
          
          if (code == 200) {
            if(data.data) {
              if(data.data.data) {
                this.courseList2 = data.data.data;
              }
            }
            console.log(this.courseList2)
          }
        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      uploadSuccess(res, file) {
        console.log(res);
        let quill = this.$refs.myQuillEditor.quill;
        let length = quill.getSelection().index;
        quill.insertEmbed(length, 'image', res.data.filePath);
        quill.setSelection(length + 1);
        this.quillUpdateImg = false;
      },
      uploadError() {
        this.quillUpdateImg = false;
        this.$message.error('图片插入失败');
      },
      beforeUpload() {
        this.quillUpdateImg = true;
      },
      //endregion
      save() {
        this.$refs['messageForm'].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          }
          let params = this.form;
          let url = "/webMessage/addMessage"
          if (this.form.messageId) {
            url = "/webMessage/updateMessage"
          }
          if(params.ccId instanceof Array) {
            if(params.ccId.length > 0) {
              params.ccId = params.ccId[params.ccId.length-1];
            }
          }
          
          
          let commodityIdList = [];
          for(let commodity of this.courseList3) {
            commodityIdList.push(commodity.commodityId);
          }
          params.commodityList = commodityIdList;
          if(params.scope == 1) {
            params.commodityIdList = "";
            params.ccId = "";
          }
          if(params.scope == 2) {
            params.commodityIdList = "";
          }
          if(params.scope == 3) {
            params.ccId = "";
          }
          https.fetchPost(url, params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == 200) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$router.push('/message/message');
            } else {
              this.$message({
                type: 'info',
                message: '操作失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络错误');
              }
          );
        });
      },
      reset() {
        this.$refs.messageForm.resetFields();
        this.changeScope(this.form.scope);
      },
      loadMessageCategory() {
        this.categoryData = [];
        let params = {
          orgCode: this.form.orgCode
        };
        https.fetchPost('/webMessageCategory/list', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            if(data.data.data) {
              this.categoryData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      searchCourseType() {
        this.courseOptions = [];
        let params = {
          orgCode: this.form.orgCode
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseOptions = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      loadOrganization() {
        let params = {};
        https.fetchGet('/managerOrganization/getOrganizationList', params, 'from').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            this.organizationData = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }
        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      changeOrg() {
        this.form.categoryId = "";
        this.searchCourseType();
        this.loadMessageCategory();
      },
      handleDialogClose() {
        this.choseCommend = false;
      },
      changeScope(val) {
        if(val == 2) {
          this.showform = true;
          this.choseCommend = false;
          this.showSelected = false;
          this.form.ccId == "";
          return
        }
        if(val == 3) {
          this.showSelected = true;
          this.showform = false;
          return;
        }
        this.showform = false;
        this.choseCommend = false;
        this.showSelected = false;
      },
      showdnd() {
        this.form.scope = 3;
        this.form.ccId = "";
        this.courseList1 = JSON.parse(JSON.stringify(this.courseList3));
        if(this.form.orgCode) {
          this.getCourse();
        }
        this.showform = false;
        this.choseCommend = true;
        this.showSelected = true;
      },
    },
    created: function() {
      this.orgType = this.$store.state.orgType;
      if(this.orgType != 1) {
        this.orgEdit = true;
        this.form.orgCode = this.$store.state.orgCode;
      }
      this.loadOrganization();
      let dataForm = this.$route.params;
      if (dataForm.messageId) {
        this.title = '修改消息';
        this.orgEdit = true;
        this.form = dataForm;
        if(this.form.ccIdString) {
          this.form.ccId =  this.form.ccIdString.split('/');
        }
        if(this.form.courseList) {
          for(let course of this.form.courseList) {
            this.courseList3.push({commodityId: course.courseId, courseName: course.courseName});
            this.courseList1.push({commodityId: course.courseId, courseName: course.courseName})
          }
        }
        this.changeScope(this.form.scope);
      } else {
        this.title = '添加消息';
      }
      this.searchCourseType();
      this.loadMessageCategory();
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
    }
  };
</script>

<style>
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  .el-dialog__header {
    padding: 5px 20px;
  }
  .el-dialog__body {
    padding: 5px 20px;
  }
  .list-complete-item {
    cursor: pointer;
    position: relative;
    font-size: 14px;
    padding: 5px 12px;
    margin-top: 4px;
    border: 1px solid #bfcbd9;
    transition: all 1s;
    margin-right: 10px;
  }

  .list-complete-item-handle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 50px;
  }

</style>